import {
  AccountSettings,
  LineOfBusiness,
  NotificationPreference,
  QuoteSettings,
  RenewalNoticeStep,
} from './domain.models';
import { OFFER_VALID_DAYS, PREMIUM_TOLERANCE_PCT } from './rules';

export const NOTIFICATION_EVENTS: { event: string; label: string }[] = [
  { event: 'quote-client-choice', label: 'El cliente eligió una opción del comparativo' },
  { event: 'issuance-result', label: 'Resultado de una solicitud de emisión' },
  { event: 'renewal-due', label: 'Una póliza está por renovar' },
  { event: 'installment-overdue', label: 'Cuota vencida' },
  { event: 'claim-deadline', label: 'Plazo legal de un siniestro por vencer' },
  { event: 'ticket-escalated', label: 'Ticket escalado' },
  { event: 'policy-divergent', label: 'Póliza divergente' },
];

const DEFAULT_RENEWAL_DAYS: Partial<Record<LineOfBusiness, number[]>> = {
  auto: [60, 30, 15],
  home: [45, 15],
  commerce: [45, 15],
  liability: [45, 15],
  'personal-accident': [30],
  life: [30],
};

export const MIN_TOLERANCE_PCT = 0;
export const MAX_TOLERANCE_PCT = 20;
export const MIN_VALIDITY_DAYS = 1;
export const MAX_VALIDITY_DAYS = 90;

export function defaultPreferences(): NotificationPreference[] {
  return NOTIFICATION_EVENTS.map(e => ({ event: e.event, enabled: true, inApp: true, email: e.event !== 'ticket-escalated', notifyClient: false }));
}

export function defaultRenewalNotices(): RenewalNoticeStep[] {
  return (Object.entries(DEFAULT_RENEWAL_DAYS) as [LineOfBusiness, number[]][])
    .map(([lineOfBusiness, daysBefore]) => ({ lineOfBusiness, daysBefore }));
}

export function defaultAccountSettings(phone: string): AccountSettings {
  return {
    phone, twoFactorEnabled: false, preferences: defaultPreferences(), renewalNotices: defaultRenewalNotices(),
    templates: [],
  };
}

export function defaultQuoteSettings(): QuoteSettings {
  return {
    tolerancePct: PREMIUM_TOLERANCE_PCT, offerValidityDays: OFFER_VALID_DAYS, pdfContact: '', pdfLegalText: '', pdfLogoName: '',
  };
}
